const sort = {
  direction: {
    ASC: 'ASC',
    DSC: 'DSC',
  },
  label: {
    false: 'ASC',
    true: 'DSC',
  },
}

export default sort
